<template>
  <div>
    <b-navbar toggleable="lg" type="dark" style="background-color:#131921">
      <b-navbar-brand href="/faves">
        <b-img
            v-bind="mainProps"
          src="/assets/_birthday/tinkazon_pink.png"
          style="object-fit: scale-down"
          />
      </b-navbar-brand>

      <template v-if="false">
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item href="#">
              <div style="color:white">
                <p>
                  <b-icon icon="geo-alt"
                          scale="1"
                          variant="light"
                  />
                  Bring ... 30605
                </p>
              </div>
            </b-nav-item>
          </b-navbar-nav>
          <div>
            <b-input-group>
              <template #prepend>
                <b-dropdown text="All"
                            style="background-color:#a29c9c">
                  <b-dropdown-item>All Departments</b-dropdown-item>
                  <b-dropdown-item>Skills</b-dropdown-item>
                </b-dropdown>
              </template>

              <b-form-input
                  v-model="searchStr"
                  @input="handleSearchInput"
              />

              <template #append>
                <b-input-group-text style="background-color:#febd69">
                  <b-icon

                      icon="search"
                  />
                </b-input-group-text>
              </template>
            </b-input-group>
          </div>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-item-dropdown text="Lang" right>
              <b-dropdown-item href="#">EN</b-dropdown-item>
              <b-dropdown-item href="#">ES</b-dropdown-item>
              <b-dropdown-item href="#">RU</b-dropdown-item>
              <b-dropdown-item href="#">FA</b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item-dropdown right>
              <!-- Using 'button-content' slot -->
              <template #button-content>
                <em>User</em>
              </template>
              <b-dropdown-item href="#">Profile</b-dropdown-item>
              <b-dropdown-item href="#">Sign Out</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </template>
    </b-navbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import config from "@/assets/_config.json";
import moment from "moment";

export default {
  name: "Home_Site",
  components: {},
  computed: {},
  created() {
  },
  methods: {
    handleSearchInput(){
      this.$emit("search-input", this.searchStr);
    }
  },
  mounted() {},
  data() {
    return {
      mainProps: { blank: false, width: 250, height: 250, class: 'm1' },
      searchStr: null,
      id: "success-modal",
      config,
      loading: false,
      publishings: [
        {
          cornerURL: "/corner/the-little-ant-that-did",
          isNew: true,
          rating: 5,
          bio: "info about the book",
          imgURL:
              "https://firebasestorage.googleapis.com/v0/b/cornerqr.appspot.com/o/publishing_cover_img%2FAxXOetC3aD2DgMa?alt=media&token=02c2e90f-85db-4df1-b549-b2ec5b2171eb"
        },
        {
          cornerURL: "/corner/the-little-ant-that-did",
          isNew: true,
          rating: 5,
          bio: "info about the book",
          imgURL:
              "https://firebasestorage.googleapis.com/v0/b/cornerqr.appspot.com/o/publishing_cover_img%2FAxXOetC3aD2DgMa?alt=media&token=02c2e90f-85db-4df1-b549-b2ec5b2171eb"
        },
        {
          cornerURL: "/corner/the-little-ant-that-did",
          isNew: true,
          rating: 5,
          bio: "info about the book",
          imgURL:
              "https://firebasestorage.googleapis.com/v0/b/cornerqr.appspot.com/o/publishing_cover_img%2FAxXOetC3aD2DgMa?alt=media&token=02c2e90f-85db-4df1-b549-b2ec5b2171eb"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.coming-soon {
  padding-top: 100px;
  background: #FE828C;
}
</style>
